import styled from 'styled-components';
import { palette } from 'styled-tools';

export const ItemInfoContainer = styled.div`
    padding: 0 20px;

    > * {
        padding: 16px 0;

        &:not(:last-child) {
            border-bottom: 1px solid ${palette('gray_opacity_200')};
        }
    }
`;